<template>
  <v-container>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-text>
              <v-text-field
                type="text"
                v-model="numeroFactura"
                :rules="reglaNumeroFactura"
                label="Numero de la Factura"
                required
                outlined
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card>
            <v-card-text class="text-center">
              <v-text-field
                type="text"
                v-model="nombreEmpresa"
                :rules="textRules"
                label="Nombre de la empresa"
                required
                outlined
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" v-if="logoEmpresa" class="text-center mt-8">
          <v-avatar size="62">
            <img :src="logoEmpresa" alt="John" />
          </v-avatar>
        </v-col>
        <v-col cols="12" md="3" v-else class="text-center mt-8">
          <input type="file" ref="boton" class="d-none" @change="buscarFichero($event)" />
          <v-btn class="primary mr-2" @click="$refs.boton.click()">Cargar Logo Empresa</v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>

      <Datosempresa />
      <v-divider class="my-5"></v-divider>
      <Datoscliente />
      <h2>Artículos</h2>
      <v-row v-for="(item, index) in articulos" :key="index" class="blue lighten-5 mb-5">
        <v-col cols="12" class="text-right">
          <v-btn class="secondary">X</v-btn>
        </v-col>

        <v-col cols="12" md="6" class="mb-24">
          <v-text-field
            v-model="item.titulo"
            :rules="textRules"
            label="Titulo del arituclo"
            required
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="item.descripcion"
            label="Descripcion del articulo"
            required
            outlined
            :rules="textRules"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="item.precio"
            @change="recaulcularPrecio()"
            label="Precio Unidad"
            required
            outlined
            type="number"
            :rules="numberRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            @change="recaulcularPrecio()"
            v-model="item.cantidad"
            label="Cantidad"
            required
            outlined
            type="number"
            :rules="numberRules"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-btn class="success" @click="agregarArticulo()">Añadir un articulo</v-btn>
        </v-col>
        <v-col cols="6"></v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card class="mb-3">
            <v-card-text>
              <v-text-field
                type="number"
                v-model="iva"
                label="IVA en %"
                required
                outlined
                :rules="numberRules"
                @change="recaulcularPrecio()"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
          <v-col cols="6">
            <v-card class="mb-3">
            <v-card-text>
              <v-text-field
                type="number"
                v-model="irpf"
                label="IRPF en %"
                required
                outlined
                :rules="requiredRules"
                @change="recaulcularPrecio()"
              ></v-text-field>
            </v-card-text>
          </v-card>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="6"></v-col>
        <v-col cols="6">
          <v-card class="accent">
            <v-card-text
              class="white--text text-center font-weight-bold"
            >Total a facturar: {{totalprecio+ivaArestar - irpfArestar}} €</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            label="Terminos & Condiciones"
            v-model="condiciones"
            auto-grow
            outlined
            rows="3"
            row-height="25"
            shaped
          ></v-textarea>
        </v-col>
      </v-row>
      <GenerarDoc />
    </v-form>
  </v-container>
</template>

<script>
import Datosempresa from "@/components/Datosempresa";
import Datoscliente from "@/components/Datoscliente";
import GenerarDoc from "@/components/GenerarDoc";

import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "Factura",
  data() {
    return {
      valid: false,
      irpf:0,
      numeroFactura: "",
      nombreEmpresa: "",
      condiciones: "",
      formadepago: "recuerda añadir los detalles del pago y como hacerlo",
      iva: 21,
      irpfArestar:0,
      ivaArestar: 0,
      totalprecio: 0
    };
  },
  methods: {
    ...mapActions([
      "setLogoEmpresa",
      "cargarTerminoCondiciones",
      "cargarNombreEmpresa",
      "cargarTotalPagar",
      "cargarNumeroFactura",
      "cargarIva",
      "cargarIrpf"
    ]),
    agregarArticulo() {
      this.articulos.push({
        precio: 0,
        cantidad: 1,
        titulo: "",
        descripcion: ""
      });
    },
    recaulcularPrecio() {
      this.totalprecio = 0;

      for (let articulo of this.articulos) {
        console.log("precio articulo " + articulo.precio);
        this.totalprecio += articulo.precio * articulo.cantidad;
      }
      console.log(this.totalprecio);
      this.ivaArestar = (this.iva / 100) * this.totalprecio;
      this.irpfArestar = (this.totalprecio*(this.irpf/100))
      this.cargarTotalPagar(this.totalprecio + this.ivaArestar - this.irpfArestar);
    },
    buscarFichero(evento) {
      console.log("llega hasta aqui...");
      const tipoFichero = evento.target.files[0].type;
      console.log("tipoFichero: " + tipoFichero);

      if (tipoFichero === "image/jpg" || tipoFichero === "image/png") {
        this.setLogoEmpresa(evento.target.files[0]);
        console.log(" this.logoEmpresa --> " + this.logoEmpresa);
        this.error = null;
      } else {
        this.error = "Solo se permiten formatos del tipo: jpg o png";
        this.setLogoEmpresa(null);
        return;
      }
      const previsulizador = new FileReader();
      previsulizador.readAsDataURL(this.logoEmpresa);
      previsulizador.onload = e => {
        console.log(e.target.result);
        this.setLogoEmpresa(e.target.result);
      };
    }
  },
  computed: {
    ...mapState([
      "numberRules",
      "requiredRules",
      "textRules",
      "reglaNumeroFactura",
      "logoEmpresa",
      "articulos"
    ])
  },
  actions: {},
  mutations: {
    ...mapMutations(["cargarLogoEmpresa"])
  },
  watch: {
    condiciones: function(newValue) {
      this.cargarTerminoCondiciones(newValue);
    },
    nombreEmpresa: function(newValue) {
      this.cargarNombreEmpresa(newValue);
    },
    numeroFactura: function(newValue) {
      console.log("numeroFactura: " + newValue);
      this.cargarNumeroFactura(newValue);
    },
    iva: function(newValue) {
      console.log("cargarIva: " + newValue);
      this.cargarIva(newValue);
    },
     irpf: function(newValue) {
      console.log("cargarIrpf: " + newValue);
      this.cargarIrpf(newValue);
    }
  },
  components: {
    Datosempresa,
    Datoscliente,
    GenerarDoc
  }
};
</script>
